import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import api from "@/lib/api";

/** Small inline average-rating summary (star icon + score + count), fetched for a given user_id.
 * Renders nothing if the user has no ratings yet. */
export default function RatingSummary({ userId, testId }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!userId) return;
    api.get(`/ratings/user/${userId}`).then(({ data }) => setData(data)).catch(() => {});
  }, [userId]);

  if (!data || !data.average) return null;

  return (
    <div className="flex items-center gap-1 text-sm" data-testid={testId}>
      <Star className="h-4 w-4 fill-[#dde165] text-[#dde165]" />
      <span className="font-semibold">{data.average}</span>
      <span className="text-[#2B2B2B]/40">({data.count})</span>
    </div>
  );
}
